export default __webpack_public_path__ + "c2efb6d6ecce2dbe329bd2fadd5051fd.woff";